import React from 'react';

import { Route } from 'react-router-dom';

import CenteredContent from 'components/common/Layout/CenteredContent';
import loadable from 'helpers/lazyWithPreload';

const JiraCloudSelectSetup = loadable(
  () => import('components/integrations/components/JiraCloudSelectSetup'),
);

const GoogleCalendarSetup = loadable(
  () =>
    import(
      'components/integrations/onboarding/google_calendar/GoogleCalendarSetup'
    ),
);

const JiraCloudOnboarding = loadable(
  () => import('components/integrations/onboarding/JiraOnboarding'),
);

const ZoomSetup = loadable(
  () =>
    import('components/integrations/onboarding/zoom_onboarding/ZoomSetup.jsx'),
);

const WebexSetup = loadable(
  () =>
    import(
      'components/integrations/onboarding/webex_onboarding/WebexSetup.jsx'
    ),
);

const ServiceNowOnboarding = loadable(
  () =>
    import(
      'components/integrations/onboarding/service_now/ServiceNowOnboarding'
    ),
);

const SlackOnboarding = loadable(
  () => import('components/integrations/onboarding/slack/SlackOnboarding'),
);

// Export the routes as an array instead of a component
const integrationOnboardingRoutes = [
  <Route
    key="zoom-onboarding"
    path="settings/integrations/zoom/connections/:connectionId/onboarding"
    element={
      <CenteredContent>
        <ZoomSetup />
      </CenteredContent>
    }
  />,
  <Route
    key="webex-onboarding"
    path="settings/integrations/webex/connections/:connectionId/onboarding"
    element={
      <CenteredContent>
        <WebexSetup />
      </CenteredContent>
    }
  />,
  <Route
    key="google-calendar-onboarding"
    path="settings/integrations/google_calendar/connections/:connectionId/onboarding"
    element={
      <CenteredContent>
        <GoogleCalendarSetup />
      </CenteredContent>
    }
  />,
  <Route
    key="jira-cloud-site-selection"
    element={
      <CenteredContent>
        <JiraCloudSelectSetup />
      </CenteredContent>
    }
    path="settings/integrations/jira_cloud/site_selection/:id"
  />,
  <Route
    key="jira-cloud-connection-onboarding"
    element={
      <CenteredContent>
        <JiraCloudOnboarding />
      </CenteredContent>
    }
    path="settings/integrations/jira_cloud/connections/:connectionId/onboarding"
  />,
  <Route
    key="jira-cloud-project-onboarding"
    element={
      <CenteredContent>
        <JiraCloudOnboarding />
      </CenteredContent>
    }
    path="settings/integrations/jira_cloud/connections/:connectionId/projects/:projectId/:configId/onboarding"
  />,
  <Route
    key="service-now-onboarding"
    element={
      <CenteredContent>
        <ServiceNowOnboarding />
      </CenteredContent>
    }
    path="settings/integrations/service_now/onboarding"
  />,
  <Route
    key="service-now-connection-onboarding"
    element={
      <CenteredContent>
        <ServiceNowOnboarding />
      </CenteredContent>
    }
    path="settings/integrations/service_now/connections/:connectionId/onboarding"
  />,
  <Route
    key="service-now-project-onboarding"
    element={
      <CenteredContent>
        <ServiceNowOnboarding />
      </CenteredContent>
    }
    path="settings/integrations/service_now/connections/:connectionId/projects/:projectId/:configId/onboarding"
  />,
  <Route
    key="slack-onboarding"
    element={
      <CenteredContent>
        <SlackOnboarding />
      </CenteredContent>
    }
    path="settings/integrations/slack/connections/:connectionId/onboarding"
  />,
];

export default integrationOnboardingRoutes;
